import { FC } from "react";
import { Typography, useTheme } from "@mui/material";

const HelpContact: FC<{ number: string }> = ({ number }) => {
  const theme = useTheme();
  return (
    <Typography variant="body1" component="div">
      <Typography
        variant="body1"
        component="span"
        fontFamily={theme.fonts.bold}
      >
        Need help?
      </Typography>{" "}
      Call {number}
    </Typography>
  );
};

export default HelpContact;
